import { render } from "./TournamentAgeCategoryCreatePage.vue?vue&type=template&id=b5f7ee42"
import script from "./TournamentAgeCategoryCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentAgeCategoryCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__